export const getClient = (store) => store.app.apolloProvider.defaultClient